(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["airi-manual-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
  var h=2,m=0,s=0;
  var eH=document.getElementById('ari-h'),
      eM=document.getElementById('ari-m'),
      eS=document.getElementById('ari-s');
  if(!eH)return;
  setInterval(function(){
    if(s>0){s--}else if(m>0){m--;s=59}else if(h>0){h--;m=59;s=59}
    eH.textContent=String(h).padStart(2,'0');
    eM.textContent=String(m).padStart(2,'0');
    eS.textContent=String(s).padStart(2,'0');
  },1000);
})();

(function(){
  var btn = document.getElementById('ariVerMasBtn');
  var grid = document.getElementById('ariReviewsGrid');
  if(!btn || !grid) return;
  btn.addEventListener('click', function(){
    grid.classList.add('show-more');
    var nextReview = grid.querySelector('.more-review .review-read-button');
    if (nextReview) nextReview.focus({ preventScroll: true });
  });
})();

(function(){
  var grid = document.getElementById('ariReviewsGrid');
  var dialog = document.getElementById('ariReviewDialog');
  if (!grid || !dialog) return;
  grid.addEventListener('click', function(event){
    var card = event.target.closest('.rev-card-photo');
    if (!card || !grid.contains(card)) return;
    var button = card.querySelector('.review-read-button');
    dialog.querySelector('h3').textContent = card.querySelector('.name').textContent;
    dialog.querySelector('.stars').textContent = card.querySelector('.stars').textContent;
    dialog.querySelector('.review-dialog-text').textContent = card.querySelector('.quote').textContent;
    // Native close/Escape restores this focus synchronously. A queued close
    // listener must not refocus an old opener after the next interaction.
    button.focus({ preventScroll: true });
    dialog.showModal();
    dialog.scrollTop = 0;
  });
  dialog.querySelector('.review-dialog-close').addEventListener('click', function(){
    dialog.close();
  });
  // Require both ends outside the panel, so selecting text never dismisses it.
  var startedOutside = false;
  function outside(event){
    var rect = dialog.getBoundingClientRect();
    return event.clientX < rect.left || event.clientX > rect.right ||
      event.clientY < rect.top || event.clientY > rect.bottom;
  }
  dialog.addEventListener('pointerdown', function(event){
    startedOutside = event.target === dialog && outside(event);
  });
  dialog.addEventListener('click', function(event){
    if (startedOutside && event.target === dialog && outside(event)) dialog.close();
    startedOutside = false;
  });
})();

(function(){
  var slider = document.getElementById('ariBaSlider');
  var before = document.getElementById('ariBaBefore');
  var handle = document.getElementById('ariBaHandle');
  if(!slider || !before || !handle) return;

  function sizeLayers(){
    var w = slider.getBoundingClientRect().width;
    var kids = slider.querySelectorAll('.ba-layer > img');
    for(var i=0;i<kids.length;i++){ kids[i].style.width = w + 'px'; }
  }
  sizeLayers();
  window.addEventListener('resize', sizeLayers);

  var dragging = false;
  function setPos(clientX){
    var rect = slider.getBoundingClientRect();
    var x = Math.min(Math.max(clientX - rect.left, 0), rect.width);
    var pct = (x / rect.width) * 100;
    before.style.width = pct + '%';
    handle.style.left = pct + '%';
  }
  function start(e){ dragging = true; move(e); }
  function move(e){
    if(!dragging) return;
    var clientX = e.touches ? e.touches[0].clientX : e.clientX;
    setPos(clientX);
  }
  function stop(){ dragging = false; }

  handle.addEventListener('mousedown', start);
  slider.addEventListener('mousedown', start);
  window.addEventListener('mousemove', move);
  window.addEventListener('mouseup', stop);

  slider.addEventListener('touchstart', start, {passive:true});
  slider.addEventListener('touchmove', move, {passive:true});
  slider.addEventListener('touchend', stop);
})();

(function(){
  var chart = document.getElementById('ariTrendChart');
  var toggles = document.querySelectorAll('.ari .trend-legend-toggle');
  if (!chart || !toggles.length) return;
  toggles.forEach(function(toggle){
    toggle.addEventListener('click', function(){
      var isShown = toggle.getAttribute('aria-pressed') === 'true';
      var shownCount = Array.prototype.filter.call(toggles, function(item){
        return item.getAttribute('aria-pressed') === 'true';
      }).length;
      if (isShown && shownCount === 1) return;
      toggle.setAttribute('aria-pressed', String(!isShown));
      var line = chart.querySelector('.ari-chart-line--' + toggle.dataset.series);
      if (line) line.classList.toggle('is-hidden', isShown);
    });
  });
})();

(function () {
  if (!window.IntersectionObserver || !Element.prototype.animate || !window.matchMedia) return;
  var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (motion.matches) return;
  var scope = document.currentScript && document.currentScript.closest('.shopify-section');
  var roots = (scope || document).querySelectorAll('.ari');
  var initialized = window.__airiScrollRevealRoots || (window.__airiScrollRevealRoots = new WeakSet());
  var allowlist = '.stats-sec, .compare-wrap, .feat-card, .rev-card-photo:not(.more-review), .trust-card';
  var excluded = 'button, a, input, select, textarea, form, summary, video, audio, iframe, [role="button"], [tabindex]:not([tabindex="-1"]), [contenteditable="true"], .buy-btn, .cod-btn-area, #es-form-hook, .trend-chart-card, .ba-wrap';

  roots.forEach(function (root) {
    if (initialized.has(root)) return;
    initialized.add(root);
    var seen = new WeakSet();
    var active = new Map();
    function unsafe(target) {
      return target.matches(excluded) || target.closest(excluded) || target.querySelector(excluded) ||
        target.closest('.fi, .brand-bar, .banner, .icons-row') || target.contains(document.activeElement);
    }
    function cancel(target) {
      var animation = active.get(target);
      if (animation) {
        active.delete(target);
        animation.cancel();
      }
    }
    var observer;
    try {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var target = entry.target;
          if (!entry.isIntersecting || seen.has(target)) return;
          seen.add(target);
          observer.unobserve(target);
          if (motion.matches || unsafe(target) || !target.getClientRects().length) return;
          try {
            var animation = target.animate([
              { opacity: 0, transform: 'translateY(14px)' },
              { opacity: 1, transform: 'translateY(0)' }
            ], { duration: 420, easing: 'ease-out', fill: 'none' });
            active.set(target, animation);
            animation.finished.then(function () { cancel(target); }, function () { active.delete(target); });
          } catch (error) {
            cancel(target);
          }
        });
      }, { threshold: 0.12 });
    } catch (error) {
      return;
    }
    root.querySelectorAll(allowlist).forEach(function (target) {
      var rect = target.getBoundingClientRect();
      if (unsafe(target) || !target.getClientRects().length || rect.top < window.innerHeight) return;
      observer.observe(target);
    });
    root.addEventListener('focusin', function (event) {
      active.forEach(function (animation, target) {
        if (target.contains(event.target)) cancel(target);
      });
    });
    function reduceMotion() {
      if (!motion.matches) return;
      observer.disconnect();
      active.forEach(function (animation, target) { cancel(target); });
    }
    if (motion.addEventListener) motion.addEventListener('change', reduceMotion);
    else if (motion.addListener) motion.addListener(reduceMotion);
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
